import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  height: 100%;
`;

const StyledMain = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;
`;

export { StyledContainer, StyledMain };
